import * as types from "./../../statics/actionConstants";
import { createReducer } from "@reduxjs/toolkit";

const User = createReducer([], {
  [types.USER_DRAFT_UPDATED]: (state, action) => {
    state.DraftUpdated = action.Status;
  },
  [types.USER_SETTINGS_GLOBAL_FAVORITE_ACCOUNTS]: (state, action) => {
    state.Settings.Global.FavoriteAccounts = action.Accounts;
  },
  [types.USER_SITES]: (state, action) => {
    state.Sites = action.Sites;
  },
  [types.USER_SETTINGS_LOCAL_SIDEBAR]: (state) => {
    state.Settings.Local.Sidebar = !state.Settings.Local.Sidebar;
  },
  [types.USER_SETTINGS_LOCAL]: (state, action) => {
    let arr = action.Local;
    for (let item in arr) state.Settings.Local[item] = arr[item];
  },
  [types.USER_SETTINGS_GLOBAL]: (state, action) => {
    let arr = action.Global;
    for (let item in arr) state.Settings.Global[item] = arr[item];
  },
  [types.USER_SETTINGS_GLOBAL_LAST_USED_SETTINGS]: (state, action) => {
    state.Settings.Global.LastUsedSettings = action.LastUsedSettings;
  },
  [types.USER_SETTINGS_LOCAL_SIDEBAR_OPEN]: (state, action) => {
    state.Settings.Local.SidebarOpen = action.Open;
  },
  [types.USER_SETTINGS_GLOBAL_SIDEBAR]: (state) => {
    state.Settings.Global.Sidebar.Available =
      !state.Settings.Global.Sidebar.Available;
  },
  [types.USER_SETTINGS_GLOBAL_SIDEBAR_VISIBLE]: (state, action) => {
    state.Settings.Global.Sidebar.Visible = action.VisibilityValue;
  },
  [types.USER_SETTINGS_LOCAL_DRAFTS]: (state, action) => {
    state.Settings.Local.Drafts = action.newDrafts;
  }
});

export default User;
